import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { GetClientFilesApi } from "../../../api/request/clients/clients";
import columns from "../../../columns/clients/clientDetails/totalFile";
import { Progress } from "antd";
import SkeletonTable from "../../../components/table/SkeletonTable";
import ViewDocModal from "../../files/components/ViewDocModal";
import { useSelector } from "react-redux";

const Files = ({ tab }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [isDocOpen, setIsDocOpen] = useState(false);
  const [selectedFileForAckDocs, setSelectedFileForAckDocs] = useState(null);
  const userDetails = useSelector((state) => state?.user?.userDetails);

  const getFileList = async () => {
    if (!tab === "5") return;
    try {
      setIsLoading(true);
      let params = {
        client_id: id,
      };
      const { data } = await GetClientFilesApi(params);
      if (data?.status)
        setFiles(
          data?.data.map((item) => {
            return {
              ...item,
              ...(item?.acknowledge?.length && {
                acknowledgement_doc: (
                  <a
                    className="text-blue-500 cursor-pointer"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setSelectedFileForAckDocs(item);
                      setIsDocOpen(true);
                    }}
                  >
                    View
                  </a>
                ),
              }),
              progress: (
                <div className="min-w-[170px] w-auto">
                  <Progress
                    percent={Number(item?.completion_percentage).toFixed(0)}
                  />
                </div>
              ),
            };
          })
        );
      setIsLoading(false);
    } catch (error) {
      setFiles([]);
      setIsLoading(false);
    }
  };

  const handleNavigate = (data) => {
    if(userDetails?.role !== "admin") return;
    if (data?.status === "closed") {
      navigate(`/files_report/${data?.service_type_id}`, {
        state: { status: "closed", service: data?.service_type?.service_name },
      });
    } else if (data?.status === "inprocess") {
      navigate(`/file/${data?.service_type_id}/${data?.id}`);
    } else if (data?.status === "unsubmitted") {
      navigate(`/files_report/${data?.service_type_id}`, {
        state: {
          status: "unsubmitted",
          service: data?.service_type?.service_name,
        },
      });
    }
  };

  useEffect(() => {
    getFileList();
  }, [tab]);

  return (
    <div>
      <div className="rounded-xl p-5 bg-White">
        <p className="title mb-4">Total Files ({files.length})</p>
        <div className="overflow-x-auto">
          <SkeletonTable
            columns={columns}
            data={files}
            isLoading={isLoading}
            onRowClick={(data) => handleNavigate(data)}
          />
        </div>
      </div>

      <ViewDocModal
        isDocOpen={isDocOpen}
        setIsDocOpen={setIsDocOpen}
        selectedFileForAckDocs={selectedFileForAckDocs}
      />
    </div>
  );
};

export default Files;
